module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "weui-grid",
    style: (_vm.style),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.hasIconSlot || _vm.icon) ? _c('div', {
    staticClass: "weui-grid__icon"
  }, [_vm._t("icon", [_c('img', {
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.hasLabelSlot || _vm.label) ? _c('p', {
    staticClass: "weui-grid__label"
  }, [_vm._t("label", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77937534"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/grid/grid-item.vue
// module id = 532
// module chunks = 4